import { useMemo } from "react";
import { usePlatform } from "@platform/PlatformContext";
import { useFetchUserPhaseActions } from "@platform/hooks/useFetchUserPhaseActions";
import { PhaseActionType } from "@platform/types/dashboard.types";

export function useMeetingRelatedUserPhaseAction(
  meetingId: string | null,
  meetingType: PhaseActionType
) {
  useFetchUserPhaseActions({
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { userPhaseActions } = usePlatform();

  const meetingSurveyUserPhaseAction = useMemo(
    () =>
      userPhaseActions
        ?.filter((action) => action.type === meetingType)
        .find(
          (action) =>
            parseInt(action.binding_object_data.id, 10) ===
            parseInt(meetingId || "0", 10)
        ),
    [userPhaseActions, meetingId, meetingType]
  );

  return meetingSurveyUserPhaseAction;
}

export default useMeetingRelatedUserPhaseAction;
